import { render, staticRenderFns } from "./DeviceDetailsReviewsSkeleton.vue?vue&type=template&id=ad855c9c"
import script from "./DeviceDetailsReviewsSkeleton.vue?vue&type=script&lang=js"
export * from "./DeviceDetailsReviewsSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports